/**
 * Modelos de mensagem sugeridos.
 *
 * Sem acento de proposito: acento troca o alfabeto de GSM-7 pra UCS-2, o
 * limite cai de 160 pra 70 e a operadora cobra 2-3 envios pela mesma mensagem.
 *
 * Sem {link} no texto: o link da campanha e' anexado automaticamente no fim
 * (toggle ligado por padrao), entao os modelos terminam preparando a frase.
 * Todos cabem folgados nos 136 que sobram com o link ativo.
 */
export const MODELOS = [
  {
    id: "desconto",
    titulo: "Cupom de desconto",
    texto: "Voce ganhou R$15 de desconto! Use o cupom 15OFF em pedidos acima de R$100. Peca aqui: ",
  },
  {
    id: "volta",
    titulo: "Cliente sumido",
    texto: "Sentimos sua falta! Volte hoje e ganhe 10% no seu pedido: ",
  },
  {
    id: "novidade",
    titulo: "Novidade no cardapio",
    texto: "Novidade no cardapio! Vem conferir o que preparamos pra voce: ",
  },
  {
    id: "hoje",
    titulo: "Promocao do dia",
    texto: "So hoje: frete gratis em qualquer pedido. Aproveite: ",
  },
  {
    id: "fds",
    titulo: "Fim de semana",
    texto: "Fim de semana chegando! Ja garantiu o seu? Peca por aqui: ",
  },
];
